export enum PayerType {
    PARTNER = 'PARTNER',
    CUSTOMER = 'CUSTOMER',
}
